import * as React from 'react';
import classnames from 'classnames';
import * as styles from './Typography.module.scss';

export type HeaderVariant =
    | 'header1'
    | 'header2'
    | 'header3'
    | 'header4'
    | 'header5'
    | 'header6';

export type BodyVariant = 'body1' | 'body2' | 'body3' | 'body4' | 'body5';

export type TypographyVariant = HeaderVariant | BodyVariant;

export interface TypographyProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLHeadingElement | HTMLParagraphElement>,
        HTMLHeadingElement | HTMLParagraphElement
    > {
    variant: TypographyVariant;
}

function Typography({
    variant,
    children,
    className,
    ...props
}: React.PropsWithChildren<TypographyProps>) {
    let Component: React.ElementType = 'p';

    switch (variant) {
        case 'header1':
            Component = 'h1';
            break;
        case 'header2':
            Component = 'h2';
            break;
        case 'header3':
            Component = 'h3';
            break;
        case 'header4':
            Component = 'h4';
            break;
        case 'header5':
            Component = 'h5';
            break;
        case 'header6':
            Component = 'h6';
            break;
        default:
            // bodyX;
            break;
    }

    return (
        <Component
            {...props}
            className={classnames(className, {
                [styles.header1]: variant === 'header1',
                [styles.header2]: variant === 'header2',
                [styles.header3]: variant === 'header3',
                [styles.header4]: variant === 'header4',
                [styles.header5]: variant === 'header5',
                [styles.header6]: variant === 'header6',
                [styles.body1]: variant === 'body1',
                [styles.body2]: variant === 'body2',
                [styles.body3]: variant === 'body3',
                [styles.body4]: variant === 'body4',
                [styles.body5]: variant === 'body5',
            })}
        >
            {children}
        </Component>
    );
}

Typography.defaultProps = {
    variant: 'body4',
};

export default Typography;
